<template lang='pug'>
    el-dialog(
        :append-to-body="dialog.appendToBody"
        :modal-append-to-body="false",
        :before-close="done => $emit('dialogClose', done)",
        :custom-class="dialog.class",
        :center="!dialog.center",
        :close-on-press-escape="dialog.closeOnEscape",
        :close-on-click-modal="dialog.closeOnModal",
        :title="dialog.title",
        :show-close="dialog.showClose",
        :visible.sync="dialog.isShow",
        :width="dialog.width || '30%'"
    )
        slot(name='content')
        slot(name='footer', v-if="dialog.isFooter")
</template>

<script>
export default {
    name: 'public-dialog-component',
    props:  {
        dialog: Object
    },
    methods: {
        close (done) {
            done()
        }
    }
}
</script>
